import { createElement } from "../core/dialogBuilder.js";
import { currentContext } from "../core/dialogContext.js";
import { onCreate, onEdit } from "../core/dialogHandlerUtils.js";
import { selectDialogDropdowns } from "../dropdowns/dropdownManager.js";
import { createTimeLog, updateTimeLog } from "../../../app-table/tableManager/timeLogManager.js";
import { getContent } from "../../../app-table/tableManager/tableManager.js";
import { formatDateDE } from "../../../app-table/utils/timeUtils.js";
import { formatDateISO } from "../../../../shared/app-input/utils/dateUtils.js";

function parseBreakSegments(raw) {
    if (!Array.isArray(raw)) return [];
    return raw.map(segment => {
        if (segment && typeof segment === "object") {
            return { start: segment.start ?? segment.startTime ?? null, end: segment.end ?? segment.endTime ?? null };
        }
        const match = String(segment).match(/(\d{1,2}:\d{2}).*?(\d{1,2}:\d{2})/);
        return match ? { start: match[1], end: match[2] } : { start: null, end: null };
    });
}

function readSegmentsFromList(list) {
    return [...list.querySelectorAll('.breakSegmentRow')].map(row => ({
        start: row.querySelector('[data-break-field="start"]')?.getValue?.() ?? null,
        end:   row.querySelector('[data-break-field="end"]')?.getValue?.() ?? null,
    }));
}

function createBreakRow(index, segment, onRemove) {
    const startInput = createElement({
        type: "timepicker", class: "dialogField dialogInput", placeholder: "Start",
        attributes: { "data-break-field": "start", "data-break-index": String(index) }
    });
    startInput.setValue(segment.start ?? null, { silent: true });

    const endInput = createElement({
        type: "timepicker", class: "dialogField dialogInput", placeholder: "Ende",
        attributes: { "data-break-field": "end", "data-break-index": String(index) }
    });
    endInput.setValue(segment.end ?? null, { silent: true });

    const removeBtn = createElement({
        type: "button", class: "appManagerRemoveBtn", attributes: { type: "button", title: "Pause entfernen" },
        children: [{ type: "i", class: "fa-solid fa-xmark" }]
    });
    removeBtn.addEventListener("click", () => onRemove(index));

    return createElement({
        type: "div", class: "breakSegmentRow",
        children: [
            { type: "div", class: "breakSegmentFields", children: [startInput, endInput] },
            removeBtn
        ]
    });
}

function renderBreakSegments(list, segments) {
    list.innerHTML = "";

    if (segments.length === 0) {
        list.appendChild(createElement({ type: "p", class: "appManagerEmpty", text: "Keine Pausen erfasst" }));
        return;
    }

    const onRemove = (index) => {
        const current = readSegmentsFromList(list);
        current.splice(index, 1);
        renderBreakSegments(list, current);
    };

    segments.forEach((segment, index) => list.appendChild(createBreakRow(index, segment, onRemove)));
}

function initBreakSegments(data) {
    const content = getContent();
    const list = content?.querySelector("#breakSegmentsList");
    const addBtn = content?.querySelector("#breakSegmentsAddBtn");
    if (!list || !addBtn) return;

    renderBreakSegments(list, parseBreakSegments(data?.breakSegmentsRaw));

    addBtn.addEventListener("click", () => {
        const current = readSegmentsFromList(list);
        current.push({ start: null, end: null });
        renderBreakSegments(list, current);
    });
}

function initDefaultDate() {
    const content = getContent();
    const dateInput = content?.querySelector("#inputTimeLogDate");
    if (!dateInput) return;

    const today = new Date();
    const minDate = new Date();
    minDate.setMonth(minDate.getMonth() - 1);

    dateInput.setAttribute("max", formatDateISO(today));
    dateInput.setAttribute("min", formatDateISO(minDate));
    dateInput.setValue(formatDateISO(today), { silent: true });
}

export function buildCreateTimeLogHandlers() {
    return {
        onSave: onCreate(createTimeLog),
        setup: async () => {
            initDefaultDate();
            initBreakSegments(null);
        }
    };
}

export function buildEditTimeLogHandlers(data) {
    currentContext.id = data?.id;
    currentContext.date = data?.date ?? null;
    return {
        dateLabel: data?.date ? formatDateDE(data.date) : "",
        onSave: onEdit(updateTimeLog),
        setup: async () => {
            await selectDialogDropdowns(data);
            initBreakSegments(data);
        }
    };
}